import {Box, Button, Flex, Image, Text} from '@chakra-ui/react'
import {useNavigate, useLocation} from 'react-router-dom'
import {useEffect, useState} from 'react'
import gymRequest from '@apis/gym'
import ArrowRight from '@assets/svgs/gym/arrow_right.svg'
import SmileIcon from '@assets/svgs/gym/smile.svg'
import TickIcon from '@assets/svgs/gym/tick.svg'
import MicCard from '../components/MicCard'
import ReactPlayer from 'react-player'
import {useDispatch, useSelector} from 'react-redux'
import {
  upDateIsShowIntroduce,
  upDateTotalPronounceRecording,
  updateRerender,
} from '@redux/gym/gymSlice'
import ModalClosePage from '../components/ModalClosePage'
import TopTitle from '../components/TopTitle'
import LessonProgress from '../components/LessonProgress'
import AOS from 'aos'
import 'aos/dist/aos.css'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, PATH, SCREEN_REPORT_ERROR} from '@utils/Const'
import {isParamsValid} from '@utils'

const GymPronouncePage = () => {
  const stateGym = useSelector((state: any) => state.gym)
  const pronounceDataSpeech = stateGym.pronounceDataSpeech
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {lesson_id, lesson_name, type, entry_point, task_id} =
    useLocation().state || {}
  const [pronounces, setPronounces] = useState<any>(null)
  const [loading, setLoading] = useState<any>(true)
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const [currentPronounce, setCurrentPronounces] = useState<any>(
    pronounces?.questions[currentIndex],
  )
  const [isFinish, setIsFinish] = useState<boolean>(false)
  const [isPlayingVideo, setIsPlayingVideo] = useState<any>(true)

  useEffect(() => {
    if (!isParamsValid([lesson_id])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!lesson_id) return
    getPairList()
  }, [])

  useEffect(() => {
    AOS.init()
  }, [])

  useEffect(() => {
    if (!stateGym.isRender) {
      dispatch(updateRerender(true))
    }
  }, [stateGym.isRender])

  useEffect(() => {
    if (pronounces?.questions[0]) {
    }
    setCurrentPronounces(pronounces?.questions[currentIndex])
  }, [pronounces, currentIndex])

  useEffect(() => {
    if (currentPronounce?.video_instruction_path) {
      dispatch(upDateIsShowIntroduce(true))
    } else {
      dispatch(upDateIsShowIntroduce(false))
    }
  }, [currentPronounce])

  const getPairList = async () => {
    try {
      const pronounceList = await gymRequest.getGymLessonResult({
        lessonId: lesson_id,
        type: type,
      })
      setPronounces(pronounceList.data.data)
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const handleContinue = () => {
    dispatch(upDateTotalPronounceRecording(0))
    setIsFinish(false)
    if (pronounces?.questions.length > currentIndex + 1) {
      setCurrentIndex(pre => pre + 1)
      setIsPlayingVideo(true)
    } else {
      dispatch(upDateIsShowIntroduce(true))
      navigate('/gym/pair', {
        state: {
          lesson_id,
          lesson_name,
          type: 'CAP_TU',
          entry_point,
          task_id,
        },
      })
    }
  }

  const handleSendDetailsResults = async (
    score: any,
    ipa_lesson_detail_id: any,
    ipa_lesson_id: any,
    turn_play: any,
    type_learn: any,
    is_last_question: any,
  ) => {
    try {
      gymRequest.sendDetailsResults({
        score,
        ipa_lesson_detail_id,
        ipa_lesson_id,
        turn_play,
        type_learn,
        is_last_question,
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Flex
      h={'100vh'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      overflow={'hidden'}>
      <TopTitle lessonName={lesson_name} type={type} />
      {stateGym.isShowIntroduce && (
        <Flex
          px={{base: '16px', md: 0}}
          flexDirection={'column'}
          flexGrow={1}
          justifyContent={'center'}>
          <Flex justifyContent={'center'}>
            <ReactPlayer
              width={500}
              height={'100%'}
              playing
              controls
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
              }}
              url={currentPronounce?.video_instruction_path}
            />
          </Flex>
          <Text
            maxW={360}
            mx={'auto'}
            align={'center'}
            my={'24px'}
            fontSize={'20px'}
            color={'#8C8C8C'}
            fontWeight={600}>
            Xem video để học cách phát âm chuẩn như người bản địa nhé!
          </Text>
          <Flex justifyContent={'center'}>
            <Button
              color={'white'}
              bg={'#1890FF'}
              borderRadius={'12px'}
              display={'flex'}
              gap={'16px'}
              alignItems={'center'}
              onClick={() => dispatch(upDateIsShowIntroduce(false))}>
              Vào luyện tập ngay
              <Image src={ArrowRight} />
            </Button>
          </Flex>
        </Flex>
      )}
      {!stateGym.isShowIntroduce && !loading && (
        <Flex
          flexDirection={'column'}
          flexGrow={1}
          overflowY={'auto'}
          pb={'24px'}>
          <LessonProgress
            currentIndex={currentIndex}
            data={pronounces?.questions}
          />
          <Flex
            flexGrow={1}
            alignItems={'center'}
            px={{base: '16px', lg: 0}}
            mt={{base: '24px', lg: 0}}>
            <Flex
              maxW={'1000px'}
              mx={'auto'}
              gap={{base: '24px', md: '80px'}}
              flexDirection={{base: 'column', lg: 'row'}}
              justifyContent={'space-between'}
              alignItems={'center'}>
              {stateGym.isRender && (
                <Box maxW={'500px'} data-aos="fade-right">
                  <ReactPlayer
                    controls
                    width={'100%'}
                    height={'100%'}
                    playing={isPlayingVideo}
                    style={{
                      borderRadius: '16px',
                      overflow: 'hidden',
                      boxShadow: '0px 0px 8px 2px #ccc',
                    }}
                    url={currentPronounce?.video_path}
                    onPlay={() => setIsPlayingVideo(true)}
                  />
                </Box>
              )}

              {stateGym.isRender && (
                <Box data-aos="fade-left">
                  <Text
                    fontSize={{base: '18px', md: '24px'}}
                    color={'#8C8C8C'}
                    align={'center'}
                    fontWeight={700}>
                    Đạt 75 điểm phát âm để học tiếp
                  </Text>
                  <MicCard
                    data={currentPronounce}
                    setIsFinish={setIsFinish}
                    setIsPlayingVideo={setIsPlayingVideo}
                  />
                </Box>
              )}
            </Flex>
          </Flex>
        </Flex>
      )}
      {!stateGym.isShowIntroduce && (
        <Box borderTop={'2px solid #e5e5e5'}>
          <Flex
            maxW={'1000px'}
            py={{base: '16px', lg: '32px'}}
            px={'16px'}
            mx={'auto'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={'16px'}>
            {isFinish ? (
              <Text
                color={'#003D75'}
                fontSize={{base: '16px', md: '20px'}}
                fontWeight={700}
                display={'flex'}
                gap={'16px'}
                alignItems={'center'}>
                {stateGym.isGoodRecording ? (
                  <Image src={TickIcon} />
                ) : (
                  <Image src={SmileIcon} />
                )}
                {stateGym.isGoodRecording ? 'Xuất sắc!' : 'Cố gắng hơn nhé!'}
              </Text>
            ) : (
              <Box></Box>
            )}
            <Button
              isDisabled={!isFinish}
              color={'white'}
              borderRadius={'12px'}
              bg={'#003D75'}
              _hover={{
                bg: '#0066c4',
              }}
              _disabled={{
                bg: '#c9c9c9',
                cursor: 'unset',
              }}
              onClick={() => {
                handleContinue()
                dispatch(updateRerender(false))
                handleSendDetailsResults(
                  Math.round(Number(pronounceDataSpeech?.total_score) * 100),
                  currentPronounce?.ipa_lesson_detail_id,
                  lesson_id,
                  pronounces?.turn_play,
                  type,
                  pronounces?.questions.length == currentIndex + 1,
                )
              }}>
              Tiếp theo
            </Button>
          </Flex>
        </Box>
      )}
      <FormReportError
        feature={FEATURE_REPORT_ERROR.IPA_COURSE}
        screen={SCREEN_REPORT_ERROR.HOC_PHAT_AM}
      />
      <ModalClosePage />
    </Flex>
  )
}

export default GymPronouncePage
